// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__xcSNl","AllElements":"ErrorPage_AllElements__8d-pV"};